import { AbstractControl, ValidatorFn } from '@angular/forms';

export function SaudiNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value = control.value?.toString()?.trim();

        const invalidResult = { invalidNational: `Please enter a valid Saudi national ID number` };

        if (!/^\d{10}$/.test(value)) {
            return value?.length > 10 ? invalidResult : null;
        }

        let sum = 0;
        for (let i = 0; i < 9; i++) {
            let num = parseInt(value[i]);
            if (i % 2 === 0) {
                let doubled = num * 2;
                sum += Math.floor(doubled / 10) + (doubled % 10);
            } else {
                sum += num;
            }
        }
        let checkDigit = (10 - (sum % 10)) % 10;
        const isValid = checkDigit === parseInt(value[9]);

        return isValid ? null : invalidResult;

    };
}
